/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import ReactPlayer, { ReactPlayerProps } from "react-player";
import { BEM } from "@adapptio/lib-components";

import "./VideoPlayer.scss";

export interface IVideoPlayerProps extends ReactPlayerProps {
	className?: string;
}

export function isPlayableVideoUrl(url: string): boolean {
	return ReactPlayer.canPlay(url);
}

export const VideoPlayer: React.FC<IVideoPlayerProps> = ({ className, ...props }) => {
	const baseClass = BEM("edt-video-player");

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<ReactPlayer
				className={baseClass.element("player").toClassName()}
				width="100%"
				height="100%"
				{...props}
			/>
		</div>
	);
};
